
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPlaceholderDeviceOn as ObiPlaceholderDeviceOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-placeholder-device-on.js';
 
 
 

 
 export const ObiPlaceholderDeviceOn = createComponent({
   react: React,
   tagName: 'obi-placeholder-device-on',
   elementClass: ObiPlaceholderDeviceOnElement,
   events: {
     
   }
  });
 
 